export function concatRawBuffers(buffers) {
    let totalLength = 0;
    buffers.forEach((buffer, _) => {
        totalLength += buffer.length;
    });
    const result = new Uint8Array(totalLength);
    let currentPos = 0;
    buffers.forEach((buffer, _) => {
        result.set(buffer, currentPos);
        currentPos += buffer.length;
    });
    return result;
}
/**
 * Creates a Uint8Array view over the provided ArrayBuffer.
 * This does not copy any data (or so we hope).
 *
 * @param buffer - The source ArrayBuffer.
 * @returns A Uint8Array view over the entire buffer.
 */
export function toInt8ArrayView(x) {
    return new Uint8Array(x, 0, x.byteLength);
}
